export class CustomerPaymentTypeFilter {
    public IncludeInactive?: boolean;
}

export default CustomerPaymentTypeFilter;